/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Requirements_TitleInputs */

const en_case_requirements_title = /** @type {(inputs: Case_Requirements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required documents`)
};

const pt_br2_case_requirements_title = /** @type {(inputs: Case_Requirements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos necessários`)
};

/**
* | output |
* | --- |
* | "Required documents" |
*
* @param {Case_Requirements_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_requirements_title = /** @type {((inputs?: Case_Requirements_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Requirements_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_requirements_title(inputs)
	return pt_br2_case_requirements_title(inputs)
});